import {
  executeGet,
  executePut,
} from '../common/apiCaller'
import {
  GetChildrenSymptomDto,
  PutChildrenSymptomInputDto,
} from '../dto/childrenSymptomDto'

const apiName = 'public'
const apiPath = '/children-symptom'

export const executeGetChildrenSymptom = (id: string, facilityId: string) => {
  return executeGet<GetChildrenSymptomDto[]>(apiName, `${apiPath}/${id}`, { facilityId })
}

export const executePutChildrenSymptom = (id: string, input: PutChildrenSymptomInputDto) => {
  return executePut<null>(apiName, `${apiPath}/${id}`, input)
}